import { jsx as _jsx } from "react/jsx-runtime";
import { Select, SelectItem } from '..';
import styles from './DataTypeFilter.module.css';
const DataTypeFilter = (props) => {
    const { types, selected, setFilter } = props;
    return (_jsx("div", Object.assign({ className: styles.selectButton }, { children: _jsx(Select, Object.assign({ listClassName: styles.selectButton, title: selected }, { children: types.map((option) => (_jsx(SelectItem, Object.assign({ onSelect: () => setFilter(option), variant: "outlined", isSelected: selected === option }, { children: option }), option))) }), void 0) }), void 0));
};
export default DataTypeFilter;
